import { Routes } from './routes';

export { FiscalSimulatorClient } from './routes/FiscalSimulatorClient';

export const FiscalSimulatorRoute = Routes;
